/**
 * 设置cookie
 * @param {*} key cookie key
 * @param {*} value cookie value
 * @param {*} expHour 过期小时数 默认24h
 */
const setCookie = function(key, value, expHour) {
    if (expHour) {
        const exp = new Date();
        exp.setTime(exp.getTime() + expHour * 60 * 60 * 1000);
        document.cookie = `${key}=${value};expires=${exp.toGMTString()};max-age=${expHour * 60 * 60}`;
    } else {
        document.cookie = `${key}=${value}`;
    }
};

const getCookie = function(key) {
    const reg = new RegExp(`(^| )${key}=([^;]*)(;|$)`);
    const match = document.cookie.match(reg);
    if (match) {
        return arr[2];
    } else {
        return undefined;
    }
};

const delCookie = function(key) {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);
    const cookieValue = getCookie(key);
    if (cookieValue != null) {
        document.cookie = `${key}=${cookieValue};expires=${exp.toGMTString()}`;
    }
};

const setLocalStorage = function(key, value) {
    if (!window.localStorage) return;
    return window.localStorage.setItem(key, value);
};

const getLocalStorage = function(key) {
    if (!window.localStorage) return;
    return window.localStorage.getItem(key) || undefined;
};

const delLocalStorage = function(key) {
    if (!window.localStorage) return;
    return window.localStorage.removeItem(key);
};

export {
    setCookie,
    getCookie,
    delCookie,
    setLocalStorage,
    getLocalStorage,
    delLocalStorage
};



// WEBPACK FOOTER //
// ./src/util/storage.js